import i18next from 'i18next';

i18next.addResources('es_CL', 'Login', {
  welcome: 'Bienvenido al KDS'
});

i18next.addResources('es_CR', 'Login', {
  welcome: 'Bienvenido al KDS'
});
